<!--菜单-->
<template>
    <div>
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" >
				<el-form-item>
					<el-input  placeholder="菜单名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getUsers">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="add()">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
        <!-- 注入数组tableData -->
        <el-table :data="tableData" border >
            <!-- 在el-table-column中用prop属性来对应对象中的键名即可填入数据 -->
            <el-table-column
            prop="id"
            label="主键编号"
            width="200px">
            </el-table-column>
            <el-table-column
            prop="resName"
            label="资源名称"
            width="100">
            </el-table-column>
            <el-table-column
            prop="resPath"
            label="资源路径"
            width="100">
            </el-table-column>
            <el-table-column
            prop="parentId"
            label="上级资源"
            width="200">
            </el-table-column>
            <el-table-column
            prop="resIcon"
            label="资源图标"
            width="100">
            </el-table-column>
            <el-table-column
            prop="resDesc"
            label="资源描述"
            width="100">
            </el-table-column>
            <el-table-column
            prop="resSort"
           
            label="菜单排序"
            width="100">
            </el-table-column>
            <el-table-column
            prop="resOpen"
            label="是否展开"
            :formatter="formatterColumn"
            width="100" >
            </el-table-column>
            <el-table-column
            prop="state"
            label="状态"
            width="100">
            </el-table-column>






            <el-table-column label="操作"  min-width="150">
            <template slot-scope="scope">
                <!-- 使用函数名(scope.$index,scope.row)获取行数据  调用时函数名(index, row)-->
                <el-button size="small" @click="edit(scope.$index,scope.row)">编辑</el-button>
                <el-button size="small" type="danger" @click="deleteRow(scope.$index, scope.row)">删除</el-button>
            </template>
            </el-table-column>
        </el-table>
        <!--编辑界面-->
        <!-- :visible.sync=boolean 控制对话框的显示和隐藏 -->
                 <el-dialog :title="formtitle" :visible.sync="dialogFormVisible">
                     <!-- 用v-model绑定数据form  在这里拿到的选择行的数据-->
                    <el-form v-model="form" label-width="100px">
                         <el-form-item aria-placeholder="请输入" label="主键编号">
                            <el-input v-model="form.id"  :readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="资源名称">
                            <el-input v-model="form.resName"></el-input>
                        </el-form-item>
                        <el-form-item label="资源路径">
                            <el-input v-model="form.resPath"></el-input>
                        </el-form-item>
                        <el-form-item label="上级资源">
                            <el-input v-model="form.parentId"></el-input>
                        </el-form-item> 
                         <el-form-item label="菜单排序">
                            <el-input v-model="form.resSort"></el-input>
                        </el-form-item> 
                        <el-form-item label="是否展开">
                            <el-input v-model="form.resOpen"></el-input>
                        </el-form-item> 
                         <el-form-item label="状态">
                            <el-input v-model="form.state"></el-input>
                        </el-form-item> 
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="open2()">确 定</el-button>
                    </div>
                    </el-dialog> 
            </div>    


</template>


<script>
  import { url, RequestGet, RequestPost } from '../../api/api';
  export default {
    methods: {
      deleteRow(index, rows) {
       this.$confirm('是否确认删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
          RequestPost("/main/deleteMenu",rows).then(response=>{
                 if(response.code=='0000'){
                    this.$message({
                        message: response.message,
                        type: 'success'
                    });  
                    this.dialogFormVisible = false;
                }else{
                    this.$message({
                        message: response.message,
                        type: 'error'
                    });
                }
                this.loadData();
          });
            this.dialogFormVisible = false;
            
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });
      },
      edit(index,rows){
           this.formtitle="修改菜单";
           this.form = rows;
           this.dialogFormVisible = true;   
           this.readonly=true;
      },
      add(){
          this.form={};
          this.formtitle="新增菜单";
          this.dialogFormVisible = true;   
          this.readonly=false;
      },
      getUsers(){

      },
       open2() {

        if(this.formtitle=="新增菜单"){
            RequestPost("/main/addMenu",this.form).then(response=>{
                console.log(response);
                	if(response.code=='0000'){
							this.$message({
								message: response.message,
								type: 'success'
							});  
                    }else{
							this.$message({
								message: response.message,
								type: 'error'
							});
						}
						this.loadData();
                    	this.dialogFormVisible = false;
            })
        }
        if(this.formtitle=="修改菜单"){
            RequestPost("/main/updateMenu",this.form).then(response=>{
                console.log(response);
                if(response.code=="0000"){
                    this.$message({
                        message:response.message,
                        type:"success"
                    });
                }else{
                    this.$message({
                        message:response.message,
                        type:"erroe"
                    });
                }
                this.loadData();
                this.dialogFormVisible = false;
            });
        }
           
      },
      formatterColumn(row, column) {
            switch(row.state){
                
                case "10":
                return '审核通过';
                break;

                case "20":
                return '待审核';
                break;

                default:
                return '未知';
            }
        },
     loadData(){
 this.$axios.get(url+'/main/findVueMenuAll').then(response => {
                 this.tableData = response.data.data;
        
            }).catch(error => {
                  console.log(error)
          })
    },
    },
    created:function(){
          this.loadData();
    },
   
    data() {
      return {
          form:{},
        tableData: [],
        formcolWidth:'100',
        dialogFormVisible: false,
        formtitle:"",
        readonly:false
      }
    }
  }
</script>
<style >
	.el-dialog--small {
		 width: 30%; 
	}
</style>


// WEBPACK FOOTER //
// resource.vue?162fbd76